import styled from 'styled-components'

import { Skeleton } from '@root/shared/ui-kit'

import { AvgBuyMcDistributionTrackSkeleton } from './avg-buy-mc-distribution-column-skeleton'
import { AvgBuyMcDistributionCommon } from './avg-buy-mc-distribution-common'

import type { ClassNameProps } from '@root/shared/react'

type Props = {} & ClassNameProps
const COLUMNS = [0, 1, 2]

export const AvgBuyMcDistributionSkeleton = (props: Props) => {
  return (
    <AvgBuyMcDistributionCommon className={props.className}>
      <Main columns={COLUMNS.length}>
        {COLUMNS.map((n) => (
          <Skeleton.Line key={n} />
        ))}
        {COLUMNS.map((column, i) => (
          <AvgBuyMcDistributionTrackSkeleton key={i} />
        ))}
      </Main>
    </AvgBuyMcDistributionCommon>
  )
}

const Main = styled.div<{ columns: number }>`
  display: grid;

  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  grid-template-rows: auto 1fr;
  gap: 8px;
`
